export default __webpack_public_path__ + "static/media/cStyleConnecting.c82adad2.png";